import { getPublishedDomain } from './publishedUrl';

const domain = getPublishedDomain(); // e.g. "competepages.com" or "compete-pages-local.com"

export const isSubdomain = (): boolean => {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');

  if (hostname.includes(domain) && parts.length >= 3) {
    const baseParts = domain.split('.');
    if (parts[0] === 'www' || parts[0] === baseParts[0]) return false;
    return true;
  }

  // Custom domain: any domain that's not the main domain or Vercel preview
  return isCustomDomain();
};

export const isCustomDomain = (): boolean => {
  const hostname = window.location.hostname;

  // Check if it's NOT one of our known domains
  return (
    !hostname.includes(domain) &&
    !hostname.includes('localhost') &&
    !hostname.includes('vercel.app') &&
    // AWS ELB URLs (for staging/testing on KloudVector)
    !hostname.includes('.elb.amazonaws.com')
  );
};

export const getSubdomain = (): string => {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');

  if (hostname.includes(domain) && parts.length >= 3 && parts[0] !== 'www') {
    return parts[0];
  }

  return '';
};

export const isMainDomain = (): boolean => {
  const hostname = window.location.hostname;

  // Main domains (admin interface)
  return (
    hostname === domain ||
    hostname === `www.${domain}` ||
    hostname === 'localhost:5173' ||
    hostname === 'localhost'
  );
};
